module.exports = __webpack_public_path__ + "static/img/solutionText9.0bd9d39.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionText9.png
// module id = esk6
// module chunks = 1